import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ConfigProvider, Empty, Table } from "antd";
import style from "css/realtime.module.css";
import axios from "axios";
import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

function RealtimeList() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const getConferenceList = useCallback(() => {
    let url = "/active/list";
    // let param = {
    //   params: {
    //     SCHEDULE_TYPE: "CD0203",
    //   },
    // };
    setLoading(true);
    axios.get(url).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setConferenceList(res.data.CONFERENCE);
      }
    });
  }, []);

  const columns = [
    {
      title: t("LIST.MEETING_TITLE"),
      dataIndex: "TITLE",
      key: "TITLE",
      align: "center",
    },
    {
      title: t("LIST.MEETING_START"),
      dataIndex: "START_DATE_TIME",
      key: "START_DATE_TIME",
      align: "center",
    },
    {
      title: t("LIST.MEETING_END"),
      dataIndex: "END_DATE_TIME",
      key: "END_DATE_TIME",
      align: "center",
    },
    {
      title: (
        <ReloadOutlined
          style={{ color: "#1cb691", fontSize: "18px" }}
          onClick={getConferenceList}
        />
      ),
      width: "5%",
      align: "center",
    },
  ];
  const [loading, setLoading] = useState(false);
  const [conferenceList, setConferenceList] = useState([]);

  useEffect(() => {
    getConferenceList();
  }, [getConferenceList]);

  return (
    <div className={style.list_wrapper}>
      {/* <div className={style.btn_meeting_controll_area}>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Spoqa Han Sans Neo",
            },
            components: {
              Button: {
                colorPrimary: "#1677ff",
                colorPrimaryHover: "#69b1ff",
                colorPrimaryActive: "#003eb3",
                fontFamily: "Spoqa Han Sans Neo",
              },
            },
          }}
        >
          <Button
            size="large"
            // type="primary"
            icon={<ReloadOutlined />}
            onClick={getConferenceList}
          />
        </ConfigProvider>
      </div> */}
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Spoqa Han Sans Neo",
          },
          components: {
            Table: {
              colorTextHeading: "#595959",
              fontWeightStrong: "500",
              fontSize: "15px",
            },
            // Spin: {
            //   colorPrimary: "#1cb691",
            // },
          },
        }}
      >
        <Table
          rowKey={(record) => record.uid}
          className={style.meeting_room_table}
          loading={loading}
          columns={columns}
          dataSource={conferenceList}
          pagination={false}
          // scroll={}
          rowClassName="cursor"
          locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
          onRow={(row) => {
            return {
              onClick: () => {
                navigate(process.env.REACT_APP_CLIENT_URL + "app/realtime", {
                  state: {
                    MEETING_KEY: row.MEETING_KEY,
                    SERVER_NO: row.SERVER_NO,
                    SCHEDULE_TYPE: row.SCHEDULE_TYPE,
                    SCHEDULE_ID: row.SCHEDULE_ID,
                  },
                });
              },
            };
          }}
        />
      </ConfigProvider>
    </div>
  );
}

export default RealtimeList;
